export default {
	tabs: ["Stiahnuť", "História"],
	History: {
		tabs: ["Prehľad", "Úspech", "Odmietnuť"]
	},
	Withdraw: {
		label: ["Číslo účtu", "Objednávacie číslo", "Adresa", "Suma", "Poplatok", "Vytvorené v", "Stav", "Dôvod"]
	},
	AccountAmount: "Suma účtu",
	tips: "Výplatu dostanete do hodiny ",
	form: {
		label: ["Výška výberu", "Heslo transakcie"],
		ALL: "VŠETKY",
		Withdraw: "Odoslať"
	},
	WithdrawAccount: "Výber účtu",
	noAccountsTips: "Prosím, pridajte Spôsoby Platby",
	tradingKind: [
		"Cashback",
		"Odpočet",
		"Dobitie",
		"Výber prebieha",
		"Uvoľnenie výberu",
		"Výber",
		"Úloha",
		"Vrátenie istiny",
		"Vrátenie provízie",
		"Vrátenie podriadenej provízie",
		"Prihlásenie",
		"Manipulačný poplatok",
		"Vklad",
		"Odmena",
		"Základná mzda",
		"Hotovostná pomoc",
		"Registračný bonus",
		"Komoditné dividendy",
		"Bonus za úlohu",
		"Iné",
		"",
		"Pracovný bonus",
		"Odmeny za upgrade",
		"Dotácia",
		"Čaká na overenie",
		"Kampaň",
		"Výmena bodov",
		"Odmeny za prihlásenie",
		"Pracovné odmeny",
		"Transakcia kreditného skóre"
	]
};
